import {
    CRAFT_MACHINE_INFO_REQUEST,
    CRAFT_MACHINE_INFO_SUCCESS,
    CRAFT_MACHINE_INFO_ERROR,
} from 'state/actions/craft_machine'

const initialState = {
    loading: false,
    loaded: false,
    is_craft_machine_enabled: undefined,
    is_enhancements_enabled: undefined,
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case CRAFT_MACHINE_INFO_REQUEST:
        return {
            ...initialState,
            loading: true,
            loaded: false,
        }
    case CRAFT_MACHINE_INFO_SUCCESS:
        return {
            ...state,
            ...action.payload,
            loading: false,
            loaded: true,
        }
    case CRAFT_MACHINE_INFO_ERROR:
        return {
            ...initialState,
        }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/craft_machine.js